var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutgoingEmailCount = function SvgOutgoingEmailCount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outgoing_mail",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "outgoing_mail_FILL0_wght300_GRAD-25_opsz20",
    d: "M121.43-791.194l-.733-.733,1.462-1.5h-3.65v-1.039h3.65l-1.462-1.492.733-.737,2.686,2.751Zm-12.009-1.97a1.258,1.258,0,0,1-.924-.381,1.258,1.258,0,0,1-.381-.924v-8.3a1.26,1.26,0,0,1,.381-.922,1.255,1.255,0,0,1,.924-.383h10.372a1.265,1.265,0,0,1,.934.383,1.262,1.262,0,0,1,.38.922l.022,3.939q.061.016.125.028a.753.753,0,0,0,.133.012q-.345.022-.679.072a4.61,4.61,0,0,0-.639.142v-3.7l-5.459,3.863-5.455-3.871v7.819a.259.259,0,0,0,.075.192.259.259,0,0,0,.192.075H116.5a.55.55,0,0,0,.006.091,1.5,1.5,0,0,1,.008.173,3.206,3.206,0,0,0,.03.386q.03.235.056.389Zm.476-9.874,4.712,3.375,4.729-3.375Zm-.743,8.835v0Z",
    transform: "translate(566.884 809.635)",
    fill: "#3b3b3b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutgoingEmailCount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outgoingEmailCount.4417f09a.svg";
export { ForwardRef as ReactComponent };